<div fxLayout="row" fxLayoutAlign="center" class="m-1"  >
    <div fxFlex="100" fxFlex.gt-sm="1 1 460px" fxFlex.sm="1 1 460px" >
        <div >
            <div fxLayout="row" fxLayoutAlign="space-between center" class="pt-3 pl-3 pr-3 mb-3">
                <h3 class="primary-color m-1">{{ 'FILL-FORM-QUESTIONNAIRE-TO-PATIENT' | translate: { 'patientName': this.f.customerName.value} }}</h3>
                <button mat-stroked-button (click)="back()">
                    <mat-icon matSuffix class="mat-icon-rtl-mirror">navigate_before</mat-icon>
                    {{ 'FUTURE-VISITS.BACK' | translate}}
                </button>
            </div>

            <div [formGroup]="form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutAlign.gt-xs="start center">
                <div class="m-1 p-3 mat-elevation-z6 w-100">
                    <div fxFlex="100" fxLayout='column'>
                        <div fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                             <div fxFlex="100" class="p-1 w-100">
                                <mat-form-field class="w-100">
                                    <input matInput placeholder="{{ 'SEARCH-BY-NAME-CATEGORY' | translate }}"
                                        formControlName="search" aria-label="search">
                                    <mat-icon matSuffix>search</mat-icon>
                                    <mat-icon *ngIf="false" matIcon matSuffix (click)="form.get('search').setValue('')">
                                        clear</mat-icon>
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" class="p-1 w-100">
                                <mat-form-field class="w-100 select-branch">
                                    <mat-select  placeholder="{{ branchCaption }}"
                                        formControlName="branchID"
                                        [disabled]="isBranchReadonly">
                                        <mat-option *ngFor="let currenBranch of branches" [value]="currenBranch.ID">
                                            {{ currenBranch.Name }} </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        
                        <div fxFlex fxFlexLayout="column">

                            <div fxLayout="row" fxLayoutAlign="space-between center" class="p-2">
                                <div fxFlex="50" class="primary col">{{ 'FORM-NAME' | translate }}</div>
                                <div fxFlex="30" class="primary col">{{ 'CATEGORY' | translate }}</div>
                                <div fxFlex="20">&nbsp;</div>
                            </div>

                            <div class="container">
                                <div *ngFor="let formItem of (forms | formFilterPipe: form.get('search').value); let index=index; let odd=odd; let even=even;">

                                    <div fxLayout="row" fxLayoutAlign="space-between center"
                                        [ngClass]="{ odd: odd, even: even }" class="row p-2">
                                        <div fxFlex="50" class="col">{{ formItem.Name }}</div>
                                        <div fxFlex="30" class="col">{{ formItem.CategoryName }}</div>
                                        <div fxFlex="20" class="col">
                                            <button mat-raised-button color="primary" [disabled]="!canSelectForm()" (click)="onSelect(formItem)">{{
                                                'SELECT'| translate }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>